
<template>
  <div>
    <v-card
      class="elevation-0"
      :color="$vuetify.theme.isDark ? '' : 'grey lighten-3'"
      :outlined="$vuetify.theme.isDark"
    >
      <v-card-title>Departamentos</v-card-title>
      <v-card-text>
        <v-treeview
          :items="all_departments"
          :active.sync="selected_dept"
          return-object
          dense
          activatable
          selected-color="light-green accent-4"
          hoverable
          color="secondary"
          shaped
          ref="treeDepto"
          selection-type="independent"
        >
          <template v-slot:prepend="{ item, open }">
            <v-icon small class="ml-2">{{ open ? 'mdi-folder-open' : 'mdi-folder' }}</v-icon>
          </template>
          <template v-slot:label="{ item, open, active }">
            <span>{{item.name}}</span>
          </template>
        </v-treeview>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: "SelectDepartment",
  data() {
    return {
      selected_dept: [],
    }
  },
  computed: {
    ...mapState({
      all_departments: state => state.Department.all_departments
    })
  },
  watch: {
    selected_dept(nv, ov) {
      if (nv.length) {
        this.$emit("deptSelected", nv[0]);
      }
    }
  },
}
</script>

<style scoped>

</style>